import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalPopupComponent } from './modal-popup.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { AppTranslate, HttpLoaderFactory } from '../app.translate';
import { RouterModule } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ModalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })],
  providers: [AuthenticationService, TranslateService],
  exports: [ModalPopupComponent],
  declarations: [ModalPopupComponent]
})
export class ModalPopupModule extends AppTranslate {
  constructor(translate: TranslateService) {
    super(translate);
  }
}



// WEBPACK FOOTER //
// ./src/app/modal-popup/modal-popup.module.ts